import React, { useEffect } from 'react';
import api from '../../../api';            // axios 인스턴스
import {formatNumber} from '../../../util';  // 앞서 만든 formatNumber 함수
import styles from './AdViseStep0.module.css';
import { useState } from 'react';

const AdViseStep0 = ({setAdViseStep, stepProps, setStepProps}) => {
    const regions = [
        '공식','테스트',
        '서울','경기','대구','대전','광주',
        '부산','인천','제주','전북','전남',
        '울산','경북','경남','강원',
        '충북','충남','세종'
    ];
    const [statsLoading, setStatsLoading] = useState(false);

    const accountComponent = (region) => {
        const stat = !statsLoading && hasValidStats() ? stepProps[0][region] : null;

        return (
            <>
                <div className={styles.regionbuttontitle}>{region}</div>
                <div className={styles.regionfollowerframe}>
                    <div className={styles.regionfollowertext}>
                        {stat ? formatNumber(stat.instagram.currentCount) : '-'}
                    </div>
                    <div
                        className={
                        stat && stat.instagram.todayDelta < 0
                            ? styles.regiondeltatext2
                            : styles.regiondeltatext
                        }
                    >
                        {stat
                        ? (stat.instagram.todayDelta >= 0 ? '↑' : '↓') +
                            formatNumber(Math.abs(stat.instagram.todayDelta))
                        : '-'}
                    </div>
                </div>

                <div className={styles.regionfollowertext}>
                    {stat ? `${stat.instagram.media_count}개 / ${stat.facebook.media_count}개` : '-'}
                </div>
            </>
        );
    };

    const validStats = regions
        .filter(r => r !== '공식' && r !== '테스트')
        .map(r => stepProps[0][r])
        .filter(s => s != null);

    // 2) 평균 팔로워 수, 평균 어제 증감량 계산
    const avgFollowerCount = validStats.length
        ? Math.floor(
            validStats.reduce((sum, s) => sum + s.instagram.currentCount, 0) /
            validStats.length
        )
        : 0;

    const avgYesterdayDelta = validStats.length
        ? Math.floor(
            validStats.reduce((sum, s) => sum + s.instagram.yesterdayDelta, 0) /
            validStats.length
        )
        : 0;

    const deltaSign = avgYesterdayDelta >= 0 ? '↑' : '↓';

    async function fetchAllAccountStats() {
        if(statsLoading)
            return;

        setStatsLoading(true);
        try {
            // comma-joined 문자열로 보냄
            const { data: allStats } = await api.get(
            '/advise/admin/account',
            { params: { regions: regions.join(',') } }
            );
            // allStats === { 서울: {...}, 부산: {...}, ... }
            setStepProps(prev => {
                const newProps = [...prev];
                newProps[0] = allStats;
                return newProps;
            });
        } catch (err) {
            console.error('계정 통계 조회 실패:', err);
        } finally{
            setStatsLoading(false);
        }
    }

    function hasValidStats(){
        return Object.keys(stepProps[0]).length == regions.length;
    }

    useEffect(() => {
        setStepProps(prev => {
                return [
                    prev[0],
                    null,
                    'advise',
                    {hotple:null, hotples:[], region:null, category:'전체', currentPage:0, filterText:'',hotThreshold:999999},
                    {place:null, blogReviews:[], blogImageUrls:[], blogTexts:[], visitorReviews:[], placeId: null, reviewAnalysis: null, placeAnalysis: null, stage:0},
                    'image',
                    {blogImages:[], officialImages:[], gifImages:{}, blogCursor:0, selectedImages:[], placeId: null, thumbnailIndex: null, priorityIndex:[], selectedOfficialImages:[], authorIds:[]},
                    {imageAnalysis: [], conti:null, placeId: null, selectedImages:[], originalImages:[]},
                    {result:[], video_preview:[], ratio:'4/5', file: null, fileName: null, oriFileName: null, pages:[], pagePalettes:[], addLastPromotionPage:false},
                    {caption:null, result:null},
                    {adviseId: null, comment:'[HOTPLE 앱 출시 이벤트 진행]\n프로필의 링크 참고 부탁드려요❤️\n@hotple_kr', needComment:true, needInstagramUpload: true, needPageUpload: true, needOfficialUpload: true, resourceStatus:{}}
                ];
            }
        );

        if(!hasValidStats())
            fetchAllAccountStats();
    }, []);

    const whenCloseButtonClicked = () => {
        const close = window.confirm("AdVise.ai를 종료하고\nHOTPLE로 돌아갈까요?");
        if(close)
            window.history.back();
    };

    return (
        <div className={styles.outerframe}>
            <div className={styles.contentframe}>
                <img className={styles.closeButtonIcon} alt="" src="images/close_line.svg" onClick={()=>whenCloseButtonClicked()}/>
                    <div className={styles.titleframe}>
                        <div className={styles.logoframe}>
                                <div className={styles.logotext}>AdVise.ai</div>
                                <div className={styles.logosubtext}>
                                    <span className={styles.for}>{`for `}</span>
                                    <span className={styles.hotple}>
                                            <span>HOTPLE</span>
                                            <span className={styles.span}> 에디터</span>
                                    </span>
                                </div>
                        </div>
                    </div>
                    <div className={styles.buttonOuterFrame}>
                        <div className={styles.buttonframe2} onClick={()=>setAdViseStep(20)}>
                            <b className={styles.buttontext}>불러오기</b>
                        </div>
                        <div className={styles.buttonframe} onClick={()=>setAdViseStep(1)}>
                            <b className={styles.buttontext}>콘텐츠 제작 →</b>
                        </div>
                    </div>
                    <div className={styles.buttonOuterFrame}>
                        <div className={styles.buttonframe3} onClick={()=>setAdViseStep(30)}>
                            <b className={styles.buttontext}>인스타 댓글 관리</b>
                        </div>
                        <div className={styles.buttonframe4} onClick={()=>setAdViseStep(31)}>
                            <b className={styles.buttontext}>팔로잉 관리</b>
                        </div>
                    </div>
                    <div className={styles.statframe}>
                        <b className={styles.buttontext}>인스타 계정 통계 <span className={styles.span} onClick={()=>fetchAllAccountStats()}>🔃</span></b>
                        <div className={styles.statcontentframe}>
                                <div className={styles.followerframe}>
                                    <div className={styles.followertitle}>평균 팔로워</div>
                                    <div className={styles.followertext}>{!statsLoading && hasValidStats() ? formatNumber(avgFollowerCount) : '-'}</div>
                                </div>
                                <div className={styles.statdivider} />
                                <div className={styles.followerframe}>
                                    <div className={styles.followertitle}>전일 평균 증감량</div>
                                    <div className={
                                        !statsLoading && hasValidStats()
                                        ? (avgYesterdayDelta >= 0
                                            ? styles.deltatext
                                            : styles.deltatext2)
                                        : styles.deltatext
                                    }>
                                        {!statsLoading && hasValidStats()
                                        ? deltaSign + formatNumber(Math.abs(avgYesterdayDelta))
                                        : '-'
                                        }
                                    </div>
                                </div>
                        </div>
                    </div>
                    <div className={styles.regionstatframe}>
                        <div className={styles.regionrowframe}>
                                <a className={styles.regionbuttonframe1} href={'https://instagram.com/seoul_hotple_kr'} target="_blank" rel="noopener noreferrer">
                                    {accountComponent('서울')}
                                </a>
                                <a className={styles.regionbuttonframe1} href={'https://instagram.com/gyeonggi_hotple_kr'} target="_blank" rel="noopener noreferrer">
                                    {accountComponent('경기')}
                                </a>
                        </div>
                        <div className={styles.regionrowframe}>
                                <a className={styles.regionbuttonframe1} href={'https://instagram.com/incheon_hotple_kr'} target="_blank" rel="noopener noreferrer">
                                    {accountComponent('인천')}
                                </a>
                                <a className={styles.regionbuttonframe1} href={'https://instagram.com/daejeon_hotple_kr_'} target="_blank" rel="noopener noreferrer">
                                    {accountComponent('대전')}
                                </a>
                                <a className={styles.regionbuttonframe1} href={'https://instagram.com/gangwon_hotple_kr'} target="_blank" rel="noopener noreferrer">
                                    {accountComponent('강원')}
                                </a>
                        </div>
                        <div className={styles.regionrowframe}>
                                <a className={styles.regionbuttonframe1} href={'https://instagram.com/chungbuk_hotple_kr'} target="_blank" rel="noopener noreferrer">
                                    {accountComponent('충북')}
                                </a>
                                <a className={styles.regionbuttonframe1} href={'https://instagram.com/chungnam_hotple_kr_'} target="_blank" rel="noopener noreferrer">
                                    {accountComponent('충남')}
                                </a>
                                <a className={styles.regionbuttonframe1} href={'https://instagram.com/sejong_hotple_kr'} target="_blank" rel="noopener noreferrer">
                                    {accountComponent('세종')}
                                </a>
                        </div>
                        <hr style={{width: "100%", height:'1px', border:'none', backgroundColor: "#fff"}}/>
                        <div className={styles.regionrowframe}>
                                <a className={styles.regionbuttonframe1} href={'https://instagram.com/busan_hotple_kr'} target="_blank" rel="noopener noreferrer">
                                    {accountComponent('부산')}
                                </a>
                                <a className={styles.regionbuttonframe1} href={'https://instagram.com/daegu_hotple_kr'} target="_blank" rel="noopener noreferrer">
                                    {accountComponent('대구')}
                                </a>
                                <a className={styles.regionbuttonframe1} href={'https://instagram.com/ulsan_hotple_kr'} target="_blank" rel="noopener noreferrer">
                                    {accountComponent('울산')}
                                </a>
                        </div>
                        <div className={styles.regionrowframe}>
                                <a className={styles.regionbuttonframe1} href={'https://instagram.com/gyeongbuk_hotple_kr'} target="_blank" rel="noopener noreferrer">
                                    {accountComponent('경북')}
                                </a>
                                <a className={styles.regionbuttonframe1} href={'https://instagram.com/gyeongnam_hotple_kr_'} target="_blank" rel="noopener noreferrer">
                                    {accountComponent('경남')}
                                </a>
                                <a className={styles.regionbuttonframe1} href={'https://instagram.com/jeju_hotple_kr_'} target="_blank" rel="noopener noreferrer">
                                    {accountComponent('제주')}
                                </a>
                        </div>
                        <div className={styles.regionrowframe}>
                                <a className={styles.regionbuttonframe1} href={'https://instagram.com/gwangju_hotple_kr'} target="_blank" rel="noopener noreferrer">
                                    {accountComponent('광주')}
                                </a>
                                <a className={styles.regionbuttonframe1} href={'https://instagram.com/jeonbuk_hotple_kr'} target="_blank" rel="noopener noreferrer">
                                    {accountComponent('전북')}
                                </a>
                                <a className={styles.regionbuttonframe1} href={'https://instagram.com/jeonnam_hotple_kr'} target="_blank" rel="noopener noreferrer">
                                    {accountComponent('전남')}
                                </a>
                        </div>
                        <hr style={{width: "100%", height:'1px', border:'none', backgroundColor: "#fff"}}/>
                        <div className={styles.regionrowframe}>
                            <a className={styles.regionbuttonframe1} href={'https://instagram.com/hotple_kr'} target="_blank" rel="noopener noreferrer">
                                {accountComponent('공식')}
                            </a>
                            <a className={styles.regionbuttonframe1} href={'https://instagram.com/test_hp_kr'} target="_blank" rel="noopener noreferrer">
                                {accountComponent('테스트')}
                            </a>
                        </div>
                    </div>
            </div>
        </div>
    );
}

export default AdViseStep0;